import React, { useState, useEffect, Component } from 'react';
import axios from 'axios';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import TableView from '../../TableView';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


const ContainerDetails = ({ bLNumber, data, onhadleMarksNumbers, onhadlePackageDesc, onhadleFreightChargers, onhadleRevenueTons, onhadleRate, onhadlePer, onhadleCollect,
    onhadlePrepaid, onhadleExchageRate, onhadlePrepaidAt, onhadlePaybleAt, onhadleTotPaidNatCurrency, onhadlePlaceDateIssue, onhadleNoOfOrgBls }) => {
    // const [baseUrl, setBaseUrl] = useState('http://127.0.0.1:8000/api/');
    const [baseUrl, setBaseUrl] = useState('http://mol.evolve-demo.com/api/');
    const [pageComponent, setPageComponent] = useState('exportbl');


    const [marksNumbers, setMarksNumbers] = useState('');
    const [nowMarksNumbers, setNowMarksNumbers] = useState('');
    const [marksNumbersOn, setMarksNumbersOn] = useState(false);

    const [packageDesc, setPackageDesc] = useState('');
    const [nowPackageDesc, setNowPackageDesc] = useState('');
    const [packageDescOn, setPackageDescOn] = useState(false);

    const [freightChargers, setFreightChargers] = useState('');
    const [nowFreightChargers, setNowFreightChargers] = useState('');
    const [freightChargersOn, setFreightChargersOn] = useState(false);

    const [revenueTons, setRevenueTons] = useState('');
    const [nowRevenueTons, setNowRevenueTons] = useState('');
    const [revenueTonsOn, setRevenueTonsOn] = useState(false);

    const [rate, setRate] = useState('');
    const [nowrate, setNowRate] = useState('');
    const [rateOn, setRateOn] = useState(false);

    const [per, setPer] = useState('');
    const [nowper, setNowPer] = useState('');
    const [perOn, setPerOn] = useState(false);

    const [prepaid, setPrepaid] = useState(undefined);
    const [nowPrepaid, setNowPrepaid] = useState('');
    const [prepaidOn, setPrepaidOn] = useState(false)

    const [collect, setCollect] = useState('');
    const [nowcollect, setNowCollect] = useState('');
    const [collectOn, setCollectOn] = useState(false);

    const [exchageRate, setExchageRate] = useState('');
    const [nowExchageRate, setNowExchageRate] = useState('');
    const [exchageRateOn, setExchageRateOn] = useState(false);

    const [prepaidAt, setPrepaidAt] = useState('');
    const [nowPrepaidAt, setNowPrepaidAt] = useState('');
    const [prepaidAtOn, setPrepaidAtOn] = useState(false);

    const [paybleAt, setPaybleAt] = useState('');
    const [nowPaybleAt, setNowPaybleAt] = useState('');
    const [paybleAtOn, setPaybleAtOn] = useState(false);

    const [totPaidNatCurrency, setTotPaidNatCurrency] = useState('');
    const [nowtotPaidNatCurrency, setNowTotPaidNatCurrency] = useState('');
    const [totPaidNatCurrencyOn, setTotPaidNatCurrencyOn] = useState(false);

    const [placeDateIssue, setplaceDateIssue] = useState('');
    const [nowplaceDateIssue, setNowplaceDateIssue] = useState('');
    const [placeDateIssueOn, setplaceDateIssueOn] = useState(false);

    const [noOfOrgBls, setNoOfOrgBls] = useState('');
    const [nowNoOfOrgBls, setNowNoOfOrgBls] = useState('');
    const [noOfOrgBlsOn, setnoOfOrgBlsOn] = useState(false);



    const setperpaidVal = (e) => {
        setPrepaidOn(true)
        setNowPrepaid(e)
    }
    const setMaskNo = (e) => {
        setMarksNumbersOn(true)
        setNowMarksNumbers(e)
    }
    const pkgDesc = (e) => {
        setPackageDescOn(true)
        setNowPackageDesc(e)
    }
    const freightChargersVal = (e) => {
        setFreightChargersOn(true)
        setNowFreightChargers(e)
    }
    const revenueTonsVal = (e) => {
        setRevenueTonsOn(true)
        setNowRevenueTons(e)
    }
    const rateVal = (e) => {
        setRateOn(true)
        setNowRate(e)
    }
    const perVal = (e) => {
        setPerOn(true)
        setNowPer(e)
    }
    const collectVal = (e) => {
        setCollectOn(true)
        setNowCollect(e)
    }
    const exchageRateVal = (e) => {
        setExchageRateOn(true)
        setNowExchageRate(e)
    }
    const prepaidAtVal = (e) => {
        setPrepaidAtOn(true)
        setNowPrepaidAt(e)
    }
    const paybleAtVal = (e) => {
        setPaybleAtOn(true)
        setNowPaybleAt(e)
    }
    const totPaidNatCurrencyVal = (e) => {
        setTotPaidNatCurrencyOn(true)
        setNowTotPaidNatCurrency(e)
    }
    const placeDateIssueVal = (e) => {
        setplaceDateIssueOn(true)
        setNowplaceDateIssue(e)
    }
    const noOfOrgBlsVal = (e) => {
        setnoOfOrgBlsOn(true)
        setNowNoOfOrgBls(e)
    }

    useEffect(() => {
        if (data !== undefined) {
            setMarksNumbers(data.MarksNumbers)
            setPackageDesc(data.PackageDesc)
            setFreightChargers(data.FreightChargers)
            setRevenueTons(data.RevenueTons)
            setRate(data.Rate)
            setPer(data.Per)
            setPrepaid(data.Prepaid)
            setCollect(data.Collect)
            setExchageRate(data.ExchageRate)
            setPrepaidAt(data.PrepaidAt)
            setPaybleAt(data.PaybleAt)
            setTotPaidNatCurrency(data.TotPaidNatCurrency)
            setplaceDateIssue(data.PlaceDateIssue)
            setNoOfOrgBls(data.NoOfOrgBls)
        }

    })

    fetch(`${baseUrl}${pageComponent}/show/${bLNumber}`)
        .then(response => response.json())
        .then(data => {



        }, [])
        .catch(error => {
            console.error(error)
        });



    onhadleMarksNumbers(nowMarksNumbers !== '' ? nowMarksNumbers : marksNumbers);
    onhadlePackageDesc(nowPackageDesc !== '' ? nowPackageDesc : packageDesc);
    onhadleFreightChargers(nowFreightChargers !== '' ? nowFreightChargers : freightChargers);
    onhadleRate(nowrate !== '' ? nowrate : rate);
    onhadlePer(nowper !== '' ? nowper : per);
    onhadleRevenueTons(nowRevenueTons !== '' ? nowRevenueTons : revenueTons);
    onhadlePrepaidAt(nowPrepaidAt !== '' ? nowPrepaidAt : prepaidAt);
    onhadleCollect(nowcollect !== '' ? nowcollect : collect);
    onhadleExchageRate(nowExchageRate !== '' ? nowExchageRate : exchageRate);
    onhadlePrepaid(nowPrepaid !== '' ? nowPrepaid : prepaid);
    onhadlePaybleAt(nowPaybleAt !== '' ? nowPaybleAt : paybleAt);
    onhadleTotPaidNatCurrency(nowtotPaidNatCurrency !== '' ? nowtotPaidNatCurrency : totPaidNatCurrency);
    onhadlePlaceDateIssue(nowplaceDateIssue !== '' ? nowplaceDateIssue : placeDateIssue);
    onhadleNoOfOrgBls(nowNoOfOrgBls !== '' ? nowNoOfOrgBls : noOfOrgBls);




    const columns = ['VesselCode', 'VesselDesc', 'Active'];
    return (
        <Container>
            <ToastContainer autoClose={2000} />
            <Row className='mt-4'>
                <Col>
                    <TableView data={data} columns={columns} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form className='mt-4 bottom-border pb-3'>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Total No Of Pkgs</Form.Label>
                                    <Form.Control type="text" autoComplete="off" placeholder="" value={nowMarksNumbers ? nowMarksNumbers : marksNumbersOn == false ? marksNumbers : ''} onChange={e => setMaskNo(e.target.value)} name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Total No Of M3</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Kind Of Pkgs</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Form.Label>No Of Container</Form.Label>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>20 FT</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>40 FT</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>Over 40 FT</Form.Label>
                                    <Form.Control type="text" placeholder="" value={nowPackageDesc ? nowPackageDesc : packageDescOn == false ? packageDesc : ''} onChange={e => pkgDesc(e.target.value)} autoComplete="off" name="" />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Form.Group className="mb-3" controlId="MasterBL">
                                    <Form.Label>Carrier identifier</Form.Label>
                                    <Form.Control type="text" value={nowExchageRate ? nowExchageRate : exchageRateOn == false ? exchageRate : ''} onChange={e => exchageRateVal(e.target.value)} autoComplete="off" placeholder="" name="BlNo" />
                                </Form.Group>
                            </Col>
                            <Col>
                                <Form.Group className="mb-3" controlId="formGroupEmail">
                                    <Form.Label>SLPA Reference No fo vessel</Form.Label>
                                    <Form.Control type="text" value={nowPrepaidAt ? nowPrepaidAt : prepaidAtOn == false ? prepaidAt : ''} onChange={e => prepaidAtVal(e.target.value)} placeholder="" autoComplete="off" name="Hbl" />
                                </Form.Group>
                            </Col>
                        </Row>
                       
                    </Form>
                </Col>
            </Row>
        </Container>

    );

}

export default ContainerDetails;